import { useMemo } from "react";
import PropTypes from "prop-types";
import { videoExtensions, PLACEHODERIMAGE } from "Constants/constants";

const PreviewMediaUrls = ({
  sourceUrl,
  showVideoAmbientEffect,
  showImageAmbientEffect,
  videoProps = {},
  imageProps = {},
  containerStyleProps = {},
  onClick=()=>{}
}) => {
  if(!sourceUrl) sourceUrl = PLACEHODERIMAGE
  const isVideo = useMemo(() => {
    return videoExtensions?.some((ext) => sourceUrl?.endsWith(ext)) ?? false;
  }, [sourceUrl]);
  return (
    <div onClick={onClick} {...containerStyleProps} className={"relative w-full h-full " + containerStyleProps?.className ?? ""}>
      {isVideo ? (
        <>
          {showVideoAmbientEffect && (
            <div
              className="absolute top-0 left-0 w-full h-full"
              style={{
                zIndex: -1,
                background: "transparent",
              }}
            >
              <video
                src={sourceUrl}
                muted
                autoPlay
                loop
                className="w-full h-full object-cover"
                style={{
                  zIndex: 0,
                  background: "transparent",
                  filter: "blur(10px)",
                }}
              ></video>
            </div>
          )}
          <video
            src={sourceUrl}
            muted={true}
            autoPlay={true}
            loop={true}
            controls={false}
            className="w-full h-full"
            {...videoProps}
          ></video>
        </>
      ) : (
        <>
          {showImageAmbientEffect && (
            <div
              className="absolute top-0 left-0 w-full h-full"
              style={{
                zIndex: -1,
                background: "transparent",
              }}
            >
              <img
                src={sourceUrl}
                alt="items"
                className="w-full h-full object-cover"
                style={{
                  zIndex: 0,
                  background: "transparent",
                  filter: "blur(10px)",
                }}
              />
            </div>
          )}
          <img
            src={sourceUrl}
            alt="items"
            className="w-full h-full"
            style={{objectFit:"contain"}}
            {...imageProps}
          />
        </>
      )}
    </div>
  );
};
const styleProps = PropTypes.shape({
  style: PropTypes.object,
  className: PropTypes.string,
})
PreviewMediaUrls.propTypes = {
  sourceUrl: PropTypes.string.isRequired,
  showVideoAmbientEffect: PropTypes.bool,
  showImageAmbientEffect: PropTypes.bool,
  videoProps: styleProps,
  imageProps: styleProps,
  containerStyleProps: styleProps,
};

export default PreviewMediaUrls